import { QuotesList } from './QuotesList';
import { QuoteShow } from './QuoteShow';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

export default {
  list: QuotesList,
  show: QuoteShow,
  icon: RequestQuoteIcon,
};
